/* Javascript della sezione "Pagina prodotto".
 *
 * Stava dentro `{% javascript %}` in `sections/main-product.liquid`, ed e'
 * uscito quando quel file ha sfondato il limite di 256 KB che Shopify
 * impone al contenuto di una sezione (schema escluso).
 *
 * Il trasloco e' innocuo: dentro `{% javascript %}` il Liquid non viene
 * eseguito, quindi questo era gia' testo statico. Viene caricato con
 * `defer` dal file della sezione.
 */
/* LA PAGINA NON DEVE SALTARE QUANDO SI APRE UN ACCORDION
   Con la fisarmonica esclusiva, aprirne uno CHIUDE quello prima. Se quello
   che si chiude e' sopra ed era lungo, il documento si accorcia di colpo e
   tutto quello che sta sotto risale: il dito era su un titolo e un istante
   dopo quel titolo e' altrove. Non e' un'animazione brusca, e' proprio il
   punto di riferimento che sparisce.

   Il rimedio e' semplice: si guarda dov'era il titolo cliccato rispetto alla
   finestra PRIMA, e dopo il cambio si riporta lo scorrimento perche' resti
   dov'era. Chi ha cliccato vede aprirsi la sezione sotto il dito, che e'
   quello che si aspetta. */
(function () {
  document.addEventListener('click', function (e) {
    var testa = e.target.closest && e.target.closest('.product-details__accordion-trigger, .product-details__accordion > summary');
    if (!testa) return;
    var dettaglio = testa.closest('details');
    if (!dettaglio || !dettaglio.hasAttribute('name')) return;  // solo a fisarmonica

    var prima = testa.getBoundingClientRect().top;
    // due giri: uno per il cambio di stato, uno perche' il browser abbia
    // finito di ricalcolare le altezze
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var dopo = testa.getBoundingClientRect().top;
        var salto = dopo - prima;
        if (Math.abs(salto) > 1) window.scrollBy(0, salto);
      });
    });
  }, true);
})();

/* Segna da che lato la striscia delle miniature continua, cosi' il CSS puo'
   sfumare quel bordo. Senza, la barra nascosta non lascia alcun indizio. */
(function () {
  function aggiorna(striscia) {
    var spazio = striscia.scrollWidth - striscia.clientWidth;
    if (spazio <= 2) { striscia.removeAttribute('data-overflow'); return; }
    var inizio = striscia.scrollLeft > 2;
    var fine = striscia.scrollLeft < spazio - 2;
    striscia.setAttribute('data-overflow', inizio && fine ? 'both' : (inizio ? 'start' : 'end'));
  }

  function collega(striscia) {
    if (striscia.dataset.overflowInit) return;
    striscia.dataset.overflowInit = '1';
    aggiorna(striscia);
    striscia.addEventListener('scroll', function () { aggiorna(striscia); }, { passive: true });
    if (window.ResizeObserver) {
      // Le miniature cambiano larghezza con la finestra: senza osservarle,
      // la sfumatura resterebbe quella calcolata al primo disegno.
      new ResizeObserver(function () { aggiorna(striscia); }).observe(striscia);
    }
  }

  function avvia(radice) {
    (radice || document).querySelectorAll('.product-gallery__thumbs').forEach(collega);
  }

  document.addEventListener('DOMContentLoaded', function () { avvia(); });
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
  avvia();
})();

  class LyttaProductGallery extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const signal = this._ac.signal;

      this.layout = this.dataset.layout || 'sticky_gallery';
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.lightbox = this.querySelector('#GalleryLightbox');
      this.lightboxImg = this.querySelector('#LightboxImg');
      this.counterCurrent = this.querySelector('[data-counter-current]');
      this.counterTotal = this.querySelector('[data-counter-total]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.current = 0;
      this._signal = signal;

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.thumb)));
      });

      // Prev/next nav arrows (desktop hover)
      this.prevBtn?.addEventListener('click', () => {
        const idx = (this.current - 1 + this.slides.length) % this.slides.length;
        this.goTo(idx);
      });
      this.nextBtn?.addEventListener('click', () => {
        const idx = (this.current + 1) % this.slides.length;
        this.goTo(idx);
      });

      // Mouse drag on the main image to change slide (desktop). Threshold
      // matches the touch swipe (40px) so the gesture feels consistent.
      // Only initialised in non-stacked layouts (stacked already shows
      // every image vertically, drag would feel wrong).
      if (this.layout !== 'stacked') {
        this._initMouseDrag();
      }

      // Add `playsinline` (iOS inline playback) + `muted` (required
      // for browser-allowed autoplay) to all <video> elements in the
      // gallery. Shopify's `video_tag` filter doesn't expose either
      // as direct params — without playsinline, iOS Safari forces
      // fullscreen on play AND can prevent the poster from rendering
      // inline; without muted, autoplay is blocked.
      this.querySelectorAll('video.product-gallery__video').forEach(v => {
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        if (v.hasAttribute('autoplay')) {
          v.muted = true;
          v.setAttribute('muted', '');
        }
      });

      // Magnifier icon (🔍) opens the fullscreen lightbox.
      this.querySelectorAll('[data-zoom]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.openLightbox(btn.dataset.src);
        });
      });

      // Inline zoom — click on the image toggles 2x scale with the
      // origin set to the click point. Pattern Aesop / Le Labo.
      // The mouse-drag handler suppresses this click when a real drag
      // happens, so this only fires on real clicks (under threshold).
      this.querySelectorAll('.product-gallery__img').forEach((img) => {
        this._initInlineZoom(img);
      });

      // Lightbox setup (close, nav, swipe, counter)
      this._initLightbox();

      // Sync variante — when the merchant assigns an image to a variant
      // in Shopify Admin, Shopify links it via `variant.featured_media.id`
      // which matches `media.id` from `product.media` (the value rendered
      // as `data-media-id` on each slide). The legacy `variant.featured_image.id`
      // is the Image-resource ID, NOT the Media-resource ID — they don't
      // match, so using it caused the slide lookup to silently fail. We
      // try `featured_media` first (correct), then fall back to
      // `featured_image` only if older-shaped JSON ever shows up.
      document.addEventListener('lytta:variant:changed', (e) => {
        const { variant } = e.detail;
        if (!variant) return;
        const candidateId = variant.featured_media?.id ?? variant.featured_image?.id;
        if (!candidateId) return;
        const targetId = String(candidateId);
        const idx = this.slides.findIndex(s => s.dataset.mediaId === targetId);
        if (idx > -1) this.goTo(idx);
      }, { signal });

      // Swipe gesture on the main gallery (mobile)
      // Only for sticky_gallery / standard layouts — in stacked mode all
      // images are visible and swipe would clash with page scroll.
      if (this.layout !== 'stacked') {
        this._initSwipe();
      }
    }

    disconnectedCallback() {
      this._ac?.abort();
    }

    _initSwipe() {
      const main = this.querySelector('.product-gallery__main');
      if (!main) return;

      let startX = 0;
      let startY = 0;
      let isTracking = false;
      const SWIPE_THRESHOLD = 40; // px
      const VERTICAL_TOLERANCE = 60; // px — don't hijack vertical scroll

      main.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isTracking = true;
      }, { passive: true });

      main.addEventListener('touchend', (e) => {
        if (!isTracking) return;
        isTracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = Math.abs(e.changedTouches[0].clientY - startY);
        // Ignore if the user was scrolling vertically
        if (dy > VERTICAL_TOLERANCE) return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;

        // Si gira in tondo, come le frecce, il trascinamento col mouse e
        // la lente: dall'ultima foto si torna alla prima. Fermarsi in fondo
        // e' quello che faceva prima, e sul telefono, dove non ci sono le
        // frecce, sembrava un carosello rotto.
        const total = this.slides.length;
        if (dx < 0) {
          // swipe left → next
          this.goTo((this.current + 1) % total);
        } else {
          // swipe right → prev
          this.goTo((this.current - 1 + total) % total);
        }
      }, { passive: true });
    }

    goTo(index) {
      this.slides[this.current]?.classList.remove('is-active');
      this.thumbs[this.current]?.classList.remove('is-active');
      this.current = index;
      this.slides[this.current]?.classList.add('is-active');
      this.thumbs[this.current]?.classList.add('is-active');
      // `block: 'nearest'` is critical here. Without it the default
      // `block: 'start'` makes the browser scroll the *page* vertically
      // to bring the thumbnail to the top of the viewport — which on
      // mobile (and on desktop sticky_gallery) reads as an annoying
      // anchor-jump every time the user clicks a thumb. We only want
      // to scroll the thumbnail strip horizontally if needed.
      this.thumbs[this.current]?.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });

      // Update the counter pill (zero-padded "01/06" format)
      if (this.counterCurrent) {
        this.counterCurrent.textContent = String(this.current + 1).padStart(2, '0');
      }

      // In stacked mode all images are visible — scroll the active one into view
      if (this.layout === 'stacked') {
        this.slides[this.current]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /**
     * Mouse-drag navigation on the main gallery (desktop).
     * Mirrors the touch swipe gesture but for cursor input. Threshold
     * is 40px horizontal — under that we treat it as a click (so the
     * zoom-on-click behaviour still triggers). Sets `is-dragging` class
     * during the drag so CSS can swap the cursor and disable hover scale.
     */
    _initMouseDrag() {
      const main = this.querySelector('.product-gallery__main');
      if (!main) return;

      let startX = 0;
      let dragging = false;
      const THRESHOLD = 40;

      main.addEventListener('mousedown', (e) => {
        // Only react to primary button, and ignore drags that start on
        // a button (zoom, prev, next) — those have their own handlers.
        if (e.button !== 0) return;
        if (e.target.closest('button')) return;
        startX = e.clientX;
        dragging = true;
      });

      // Listen on document so a drag that ends outside the gallery still
      // gets a release event (browser default behaviour for mouse up).
      const onUp = (e) => {
        if (!dragging) return;
        dragging = false;
        main.classList.remove('is-dragging');
        const dx = e.clientX - startX;
        if (Math.abs(dx) >= THRESHOLD) {
          if (dx < 0) {
            this.goTo((this.current + 1) % this.slides.length);
          } else {
            this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
          }
          // Suppress the imminent click event so a drag-release on the
          // image doesn't also open the zoom lightbox.
          const swallow = (ev) => { ev.stopPropagation(); ev.preventDefault(); };
          main.addEventListener('click', swallow, { capture: true, once: true });
        }
      };
      document.addEventListener('mouseup', onUp, { signal: this._signal });

      main.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        const dx = Math.abs(e.clientX - startX);
        // Add `is-dragging` after a small movement to avoid flicker on
        // simple clicks (the user moved their hand a couple of pixels).
        if (dx > 5) main.classList.add('is-dragging');
      });

      // If the user leaves the page mid-drag, release cleanly.
      main.addEventListener('mouseleave', () => {
        if (dragging && !main.classList.contains('is-dragging')) {
          dragging = false;
        }
      });
    }

    openLightbox(src, alt) {
      if (!this.lightbox || !this.lightboxImg) return;
      // Don't open with an empty / placeholder src — would show a black box that traps the user
      if (!src || src.startsWith('data:image/gif')) return;
      this.lightboxIndex = this.current; // start at the slide currently visible
      this._loadLightboxAt(this.lightboxIndex, src, alt);
      this.lightbox.showModal();
    }

    /**
     * Loads the source image for a given slide index into the lightbox
     * <img>. Reads the high-res zoom URL from the slide's
     * `[data-zoom]` button, falls back to the visible img src.
     */
    _loadLightboxAt(idx, srcOverride, alt) {
      const slide = this.slides[idx];
      if (!slide) return;
      const zoomBtn = slide.querySelector('[data-zoom]');
      const visibleImg = slide.querySelector('img');
      const src = srcOverride || zoomBtn?.dataset.src || visibleImg?.src;
      if (!src) return;
      this.lightboxImg.src = src;
      this.lightboxImg.alt = alt || visibleImg?.alt || '';
      this.lightboxIndex = idx;
      // Update lightbox counter pill
      const counter = this.querySelector('[data-lightbox-current]');
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0');
    }

    /**
     * Inline zoom — Aesop-style. Click on the image toggles 2x scale
     * with `transform-origin` set to the click point so the zoom lands
     * exactly where the user clicked. Click again returns to normal.
     * On mousemove (while zoomed), the origin follows the cursor for a
     * panning effect — natural and no JS-driven transform animation.
     */
    _initInlineZoom(img) {
      const slide = img.closest('.product-gallery__slide');
      if (!slide) return;

      img.addEventListener('click', (e) => {
        // If a real drag just happened, the drag handler will have
        // suppressed the click — but as a safety net, ignore clicks
        // that originated on a button (zoom/prev/next).
        if (e.target.closest('button')) return;
        e.preventDefault();

        const isZoomed = slide.classList.contains('is-zoomed');
        if (isZoomed) {
          slide.classList.remove('is-zoomed', 'is-panning');
          img.style.transformOrigin = '';
        } else {
          // Compute origin from click position (% relative to image rect)
          const rect = img.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
          slide.classList.add('is-zoomed');
        }
      });

      // Pan: while zoomed, mousemove updates the transform origin so
      // the user can explore the image without dragging.
      img.addEventListener('mousemove', (e) => {
        if (!slide.classList.contains('is-zoomed')) return;
        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });

      // Mouse leaving the image while zoomed → keep zoom but freeze origin
      // (don't auto-exit, the user has to click to close zoom).
    }

    /**
     * Lightbox controls — close button, click backdrop to close,
     * prev/next nav, keyboard ESC + ←/→, mobile swipe close (down).
     */
    _initLightbox() {
      if (!this.lightbox) return;

      const closeBtn = this.querySelector('[data-close-lightbox]');
      const prevBtn = this.querySelector('[data-lightbox-prev]');
      const nextBtn = this.querySelector('[data-lightbox-next]');

      closeBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.lightbox.close();
      });

      // Click backdrop (anywhere not on the image / a button) → close
      this.lightbox.addEventListener('click', (e) => {
        if (e.target.closest('button')) return;
        if (e.target === this.lightboxImg) return;
        this.lightbox.close();
      });

      // Image error → auto-close so user isn't trapped on a broken image
      this.lightboxImg?.addEventListener('error', () => this.lightbox?.close());

      // Prev/next navigation inside lightbox (with wrap-around)
      const navTo = (dir) => {
        const total = this.slides.length;
        const next = ((this.lightboxIndex ?? this.current) + dir + total) % total;
        this._loadLightboxAt(next);
      };
      prevBtn?.addEventListener('click', (e) => { e.stopPropagation(); navTo(-1); });
      nextBtn?.addEventListener('click', (e) => { e.stopPropagation(); navTo(1); });

      // Keyboard: arrows for nav (Esc is handled natively by <dialog>)
      this.lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); navTo(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); navTo(1); }
      });

      // Mobile swipe — left/right to navigate, down >100px to close
      let sx = 0, sy = 0, tracking = false;
      this.lightbox.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      this.lightbox.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dy) > 100 && Math.abs(dy) > Math.abs(dx)) {
          // Swipe down (or up) hard → close
          this.lightbox.close();
          return;
        }
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          navTo(dx < 0 ? 1 : -1);
        }
      }, { passive: true });

      // When lightbox closes, sync main gallery to whatever slide the
      // user navigated to inside the lightbox (so closing doesn't jump
      // back to the original image).
      this.lightbox.addEventListener('close', () => {
        if (this.lightboxIndex != null && this.lightboxIndex !== this.current) {
          this.goTo(this.lightboxIndex);
        }
      });
    }
  }
  customElements.define('lytta-product-gallery', LyttaProductGallery);

  /* ============================================================
     SHARE BUTTONS (Web Share API + copy link)
     ============================================================ */
  class LyttaShare extends HTMLElement {
    connectedCallback() {
      this.nativeBtn = this.querySelector('[data-share-native]');
      this.copyBtn = this.querySelector('[data-share-copy]');
      this.status = this.querySelector('[data-share-status]');

      this.url = window.location.href;
      this.title = document.title;

      if (navigator.share) {
        document.documentElement.classList.add('has-web-share');
      }

      this.nativeBtn?.addEventListener('click', () => this.shareNative());
      this.copyBtn?.addEventListener('click', () => this.copyLink());
    }

    async shareNative() {
      if (!navigator.share) return;
      try {
        await navigator.share({ title: this.title, url: this.url });
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    }

    async copyLink() {
      const msg = window.lytta?.strings?.linkCopied || 'Link copied';
      try {
        await navigator.clipboard.writeText(this.url);
        this._flash(msg);
      } catch {
        // Fallback: select + execCommand
        const ta = document.createElement('textarea');
        ta.value = this.url;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch {}
        ta.remove();
        this._flash(msg);
      }
    }

    _flash(message) {
      if (!this.status) return;
      this.status.textContent = message;
      clearTimeout(this._timer);
      this._timer = setTimeout(() => { this.status.textContent = ''; }, 2000);
    }
  }
  customElements.define('lytta-share', LyttaShare);

  /* ============================================================
     STICKY ADD TO CART
     ============================================================ */
  class LyttaStickyAtc extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const signal = this._ac.signal;

      this.form = this.querySelector('[data-sticky-atc-form]');
      this.variantIdInput = this.querySelector('[data-sticky-atc-variant-id]');
      this.variantText = this.querySelector('[data-sticky-atc-variant]');
      this.priceEl = this.querySelector('[data-sticky-atc-price]');
      this.imageEl = this.querySelector('[data-sticky-atc-image]');
      this.submitBtn = this.querySelector('[data-sticky-atc-submit]');
      this.btnText = this.querySelector('[data-sticky-atc-btn-text]');
      this._originalBtnText = this.btnText?.textContent;

      // Trigger visibility when the main ATC scrolls out of view
      this.mainAtc = document.querySelector('.product-details__atc');
      if (this.mainAtc && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // Show sticky when main ATC is NOT visible
            const show = !entry.isIntersecting;
            this.setAttribute('aria-hidden', String(!show));
            this._togglePagePadding(show);
          });
        }, { threshold: 0.1 });
        this.io.observe(this.mainAtc);
      }

      // Keep sticky bar in sync with variant changes on the main form
      document.addEventListener('lytta:variant:changed', (e) => this._syncVariant(e.detail.variant), { signal });

      // Own submit handler — AJAX add + flyer + cart open
      this.form?.addEventListener('submit', (e) => this._handleSubmit(e));
    }

    _syncVariant(variant) {
      if (!variant) return;
      if (this.variantIdInput) this.variantIdInput.value = variant.id;
      if (this.variantText) {
        this.variantText.textContent = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
      }
      if (this.priceEl) {
        const compareHigher = variant.compare_at_price > variant.price;
        this.priceEl.innerHTML = compareHigher
          ? `<span class="sticky-atc__price-sale">${formatMoney(variant.price)}</span>
             <s class="sticky-atc__price-compare">${formatMoney(variant.compare_at_price)}</s>`
          : `<span>${formatMoney(variant.price)}</span>`;
      }
      if (this.imageEl && variant.featured_image?.src) {
        // Shopify variant image src comes without protocol
        const src = variant.featured_image.src.startsWith('//')
          ? 'https:' + variant.featured_image.src
          : variant.featured_image.src;
        this.imageEl.src = src;
      }
      if (this.submitBtn && this.btnText) {
        this.submitBtn.disabled = !variant.available;
        this.btnText.textContent = variant.available
          ? (window.lytta?.strings?.addToCart || 'Add to cart')
          : (window.lytta?.strings?.soldOut || 'Sold out');
      }
    }

    async _handleSubmit(e) {
      e.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const formData = new FormData(this.form);
      const id = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);

      this.submitBtn.disabled = true;
      const originalText = this.btnText.textContent;
      this.btnText.textContent = '...';

      try {
        await cart.add([{ id, quantity }]);

        // Trigger flyer from the sticky bar's own image
        if (typeof flyToCart === 'function' && this.imageEl) {
          flyToCart(this.imageEl);
        }

        document.dispatchEvent(new CustomEvent('lytta:cart:updated'));

        if (lytta.settings?.cartType === 'drawer') {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('lytta:cart:open'));
          }, lytta.settings?.atcFlyerEnabled ? 650 : 0);
        }

        this.btnText.textContent = '✓';
        setTimeout(() => {
          this.btnText.textContent = originalText;
          this.submitBtn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('Sticky ATC failed:', err);
        this.btnText.textContent = originalText;
        this.submitBtn.disabled = false;
      }
    }

    _togglePagePadding(show) {
      // Add bottom padding to the product page so content isn't covered
      // by the sticky bar at bottom. Only for bottom position.
      const isBottom = this.classList.contains('sticky-atc--bottom');
      if (!isBottom) return;
      const page = document.querySelector('.product-page');
      if (!page) return;

      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const cls = isMobile
        ? 'product-page--sticky-atc-active-mobile-bottom'
        : 'product-page--sticky-atc-active-desktop-bottom';

      if (show) page.classList.add(cls);
      else page.classList.remove(cls);
    }

    disconnectedCallback() {
      this._ac?.abort();
      this.io?.disconnect();
    }
  }
  customElements.define('lytta-sticky-atc', LyttaStickyAtc);

  /* ============================================================
     PRODUCT RECOMMENDATIONS
     Fetches via Shopify Section Rendering API (when source=recommendations)
     + handles carousel scroll with prev/next buttons.
     ============================================================ */
  class LyttaRecommendations extends HTMLElement {
    connectedCallback() {
      this.source = this.dataset.source;
      this.container = this.querySelector('[data-recommendations-container]');
      this.prevBtn = this.querySelector('[data-recs-prev]');
      this.nextBtn = this.querySelector('[data-recs-next]');

      // Fetch Shopify recommendations if source=recommendations
      if (this.source === 'recommendations') {
        this._fetchRecommendations();
      }

      // Carousel navigation
      if (this.classList.contains('product-recommendations--carousel')) {
        this._initCarousel();
      }
    }

    async _fetchRecommendations() {
      const productId = this.dataset.productId;
      const intent = this.dataset.intent || 'related';
      const limit = parseInt(this.dataset.limit, 10) || 4;

      if (!productId) return;

      const url = new URL('/recommendations/products', window.location.origin);
      url.searchParams.set('section_id', 'product-recommendations');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('intent', intent);
      url.searchParams.set('limit', limit);

      try {
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        // Shopify wraps the section in its own shopify-section element
        const newList = doc.querySelector('.product-recommendations__list');

        if (!newList) {
          // No recommendations returned — hide the whole block
          this.setAttribute('data-empty', 'true');
          return;
        }

        // Replace skeleton with real list
        const existingList = this.container.querySelector('.product-recommendations__list');
        if (existingList) {
          existingList.replaceWith(newList);
        } else {
          this.container.appendChild(newList);
        }

        // If the new list is empty, hide the block entirely
        if (newList.dataset.empty === 'true' || newList.children.length === 0) {
          this.setAttribute('data-empty', 'true');
        } else {
          // Reveal the injected cards. They carry [data-lytta-animate] (opacity:0
          // in critical.css) but the global IntersectionObserver only watches
          // elements present at first paint — async-injected cards are never
          // observed and would stay stuck invisible. Add is-visible directly,
          // matching what the observer does for on-load cards.
          newList.querySelectorAll('[data-lytta-animate]').forEach((el) => el.classList.add('is-visible'));
          // Re-init carousel if applicable after replacing list
          if (this.classList.contains('product-recommendations--carousel')) {
            this._initCarousel();
          }
        }
      } catch (err) {
        console.error('Recommendations fetch failed:', err);
        this.setAttribute('data-empty', 'true');
      }
    }

    _initCarousel() {
      this.list = this.querySelector('.product-recommendations__list');
      this.nav = this.querySelector('.product-recommendations__nav');
      if (!this.list || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this._scrollBy(-1));
      this.nextBtn.addEventListener('click', () => this._scrollBy(1));

      // Disable/enable buttons based on scroll position
      this.list.addEventListener('scroll', () => this._updateButtons(), { passive: true });
      // Recompute on resize: the nav hides when every card fits and reappears
      // when the row overflows (e.g. desktop 4-up ↔ mobile single-column).
      window.addEventListener('resize', () => this._updateButtons(), { passive: true });
      // Initial state
      this._updateButtons();
    }

    _scrollBy(direction) {
      if (!this.list) return;
      const firstItem = this.list.querySelector('.product-recommendations__item');
      const itemWidth = firstItem?.offsetWidth || 240;
      const gap = parseInt(getComputedStyle(this.list).gap, 10) || 16;
      this.list.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
    }

    _updateButtons() {
      if (!this.list || !this.prevBtn || !this.nextBtn) return;
      // Hide the arrows entirely when every card already fits (no horizontal
      // overflow) — e.g. 4 cards in a 4-column desktop grid. They reappear when
      // the list overflows (mobile single-column, or a higher product count).
      const overflows = this.list.scrollWidth > this.list.clientWidth + 4;
      if (this.nav) this.nav.style.display = overflows ? '' : 'none';
      const atStart = this.list.scrollLeft <= 4;
      const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 4;
      this.prevBtn.disabled = atStart;
      this.nextBtn.disabled = atEnd;
    }
  }
  customElements.define('lytta-recommendations', LyttaRecommendations);

  /* ============================================================
     ACCORDION (smooth height animation on open/close)
     ============================================================ */
  (function initAccordions() {
    const accordions = document.querySelectorAll('.product-details__accordion');
    if (accordions.length === 0) return;

    accordions.forEach(details => {
      const summary = details.querySelector('summary');
      const body = details.querySelector('.product-details__accordion-body');
      if (!summary || !body) return;

      let animating = false;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (animating) return;
        animating = true;

        const isOpen = details.hasAttribute('open');

        if (isOpen) {
          // Closing: lock current height, then animate to 0
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(() => {
            body.style.height = '0px';
          });
          const onEnd = () => {
            details.removeAttribute('open');
            body.style.height = '';
            body.removeEventListener('transitionend', onEnd);
            animating = false;
          };
          body.addEventListener('transitionend', onEnd);
        } else {
          // Opening: open, set 0 height, then animate to scrollHeight
          details.setAttribute('open', '');
          body.style.height = '0px';
          // Force layout so the browser registers the 0 before animating up
          // eslint-disable-next-line no-unused-expressions
          body.scrollHeight;
          requestAnimationFrame(() => {
            body.style.height = body.scrollHeight + 'px';
          });
          const onEnd = () => {
            body.style.height = '';
            body.removeEventListener('transitionend', onEnd);
            animating = false;
          };
          body.addEventListener('transitionend', onEnd);
        }
      });
    });
  })();

  /* ============================================================
     STOCK SHIPPING NOTE (computes cutoff message client-side from visitor's local time)
     ============================================================ */
  (function initStockShipping() {
    const els = document.querySelectorAll('[data-product-stock][data-cutoff-hour]');
    if (els.length === 0) return;

    function compute(el) {
      const cutoffHour = parseInt(el.dataset.cutoffHour, 10);
      if (isNaN(cutoffHour)) return;
      const cutoffTime = el.dataset.cutoffTime || `${cutoffHour}:00`;
      const skipWeekends = el.dataset.skipWeekends === 'true';
      const msgBefore = el.dataset.msgBefore || '';
      const msgAfter = el.dataset.msgAfter || '';
      const target = el.querySelector('[data-shipping-msg]');
      if (!target) return;

      const now = new Date();
      const currentHour = now.getHours();
      const day = now.getDay(); // 0 = Sunday, 6 = Saturday

      let useBefore = currentHour < cutoffHour;

      // On weekend (when skip enabled), shipping won't go out today regardless
      if (skipWeekends && (day === 0 || day === 6)) {
        useBefore = false;
      }

      const tpl = useBefore ? msgBefore : msgAfter;
      const html = tpl.replace(/\{time\}/g, `<strong>${cutoffTime}</strong>`);
      target.innerHTML = html;
    }

    els.forEach(compute);
  })();

  /* ============================================================
     PRICE BLOCK — recompute the compare-at price + save badge on
     variant change. The variant selector already updates the main
     price text, but the strikethrough comparison and the
     "RISPARMI X€" pill need to be re-rendered here.
     ============================================================ */
  (function initPriceBlock() {
    const priceEl = document.querySelector('[data-product-price]');
    if (!priceEl) return;

    // Use the global formatMoney from theme.js (handles all Shopify
    // money format placeholders: amount, amount_with_comma_separator,
    // amount_no_decimals, amount_with_apostrophe_separator, etc).

    document.addEventListener('lytta:variant:changed', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      // Rebuild the price markup so the strikethrough comes/goes correctly
      if (onSale) {
        priceEl.innerHTML = `
          <span class="product-details__price-sale">${formatMoney(variant.price)}</span>
          <s class="product-details__price-compare">${formatMoney(variant.compare_at_price)}</s>
        `;
      } else {
        priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
      }

      // Save badge
      const saveBadge = document.querySelector('[data-save-badge]');
      if (saveBadge) {
        if (onSale) {
          const label = saveBadge.dataset.label || saveBadge.textContent.trim().split(/\s+/)[0] || 'Risparmi';
          // Persist the label once so future updates don't lose it
          if (!saveBadge.dataset.label) saveBadge.dataset.label = label;
          const saveCents = variant.compare_at_price - variant.price;
          saveBadge.textContent = `${saveBadge.dataset.label} ${formatMoney(saveCents)}`;
          saveBadge.hidden = false;
        } else {
          saveBadge.hidden = true;
        }
      }
    });
  })();

  /* ============================================================
     INLINE CUTOFF — same compute logic as initStockShipping but
     scoped to the new `[data-inline-cutoff]` element on the
     product-details__status-row (stock + cutoff inline row).
     ============================================================ */

  /* The previous `initReviewsPlaceholder()` IIFE + the editorial
     placeholder it controlled have been removed. The preview badge
     is now a pure Judge.me drop-in (same minimal-Judge.me strategy
     used for the reviews section below) — Judge.me Core JS handles
     populating, sync, and the zero-reviews state via app settings. */


  /* ============================================================
     INLINE CUTOFF — full implementation
     ============================================================
     Drives the "Spedito oggi entro X" / "Ordina entro 2h 14m" / closed-day
     / holiday / delivery-estimate messaging on the product status row.

     Logic flow each tick:
       1. Today's date → determine if today is a holiday or a closed day.
          - Holiday  → show holiday_msg with the next open shipping day.
          - Closed day (e.g. weekend with no override) → "ships next biz day".
       2. Day is open → fetch today's cutoff (per-day override or default).
          - now < cutoff → "ship today" message. If countdown is on,
            insert a live H:MM countdown that ticks every minute.
          - now >= cutoff → "ship tomorrow" (next non-holiday non-closed day).
       3. Optional delivery-estimate suffix appended after the cutoff line.

     Performance: a single setInterval(60s) per element. Cheap. */
  (function initInlineCutoff() {
    const els = document.querySelectorAll('[data-inline-cutoff]');
    if (els.length === 0) return;

    const ITALIAN_MONTHS = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
    const ITALIAN_DAYS = ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'];

    function pad(n) { return String(n).padStart(2, '0'); }
    function ymd(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }
    function fmtItalianDate(d) {
      // "giovedì 8 maggio"
      return `${ITALIAN_DAYS[d.getDay()]} ${d.getDate()} ${ITALIAN_MONTHS[d.getMonth()]}`;
    }
    function parseHHMM(s) {
      const m = (s || '').trim().match(/^(\d{1,2}):(\d{2})$/);
      if (!m) return null;
      return { h: parseInt(m[1], 10), m: parseInt(m[2], 10) };
    }
    function parseHolidays(raw) {
      // Accepts dates separated by newline, comma, or both. Format: YYYY-MM-DD.
      return new Set(
        (raw || '')
          .split(/[\n,]+/)
          .map(s => s.trim())
          .filter(s => /^\d{4}-\d{2}-\d{2}$/.test(s))
      );
    }
    /**
     * Per-day cutoff lookup. Returns an HH:MM string or 'closed'.
     *   - mon..fri: default cutoff (or 'closed' if skip_weekends abused)
     *   - sat: el.dataset.cutoffSat (blank = closed, 'closed' = closed, 'HH:MM' = override)
     *   - sun: el.dataset.cutoffSun (same convention)
     * `skip_weekends=true` short-circuits sat/sun to 'closed' regardless
     * of the per-day overrides — it's the simple-mode kill switch.
     */
    function cutoffForDay(el, day, defaultCutoff) {
      const skipW = el.dataset.skipWeekends === 'true';
      if (day === 6) {
        if (skipW) return 'closed';
        const v = (el.dataset.cutoffSat || '').trim();
        if (!v || v.toLowerCase() === 'closed') return 'closed';
        return v;
      }
      if (day === 0) {
        if (skipW) return 'closed';
        const v = (el.dataset.cutoffSun || '').trim();
        if (!v || v.toLowerCase() === 'closed') return 'closed';
        return v;
      }
      return defaultCutoff;
    }

    function nextShippingDay(el, fromDate, defaultCutoff, holidays) {
      // Return the soonest future date (not today) that is not a holiday
      // and has a non-'closed' cutoff. Caps at 14 lookahead days defensively.
      const d = new Date(fromDate);
      for (let i = 1; i <= 14; i++) {
        d.setDate(d.getDate() + 1);
        const cut = cutoffForDay(el, d.getDay(), defaultCutoff);
        if (cut === 'closed') continue;
        if (holidays.has(ymd(d))) continue;
        return new Date(d);
      }
      return null;
    }

    function addBusinessDays(el, fromDate, days, defaultCutoff, holidays) {
      // Count `days` skipping closed days + holidays. `days=0` returns today
      // (or nextShippingDay if today is closed/holiday).
      const d = new Date(fromDate);
      let added = 0;
      // First normalise "today" if today is closed/holiday
      while (cutoffForDay(el, d.getDay(), defaultCutoff) === 'closed' || holidays.has(ymd(d))) {
        d.setDate(d.getDate() + 1);
      }
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (cutoffForDay(el, d.getDay(), defaultCutoff) === 'closed') continue;
        if (holidays.has(ymd(d))) continue;
        added++;
      }
      return d;
    }

    function compute(el) {
      const defaultCutoff = (el.dataset.cutoffDefault || '14:30').trim();
      const msgBefore = el.dataset.msgBefore || '';
      const msgAfter = el.dataset.msgAfter || '';
      const msgHoliday = el.dataset.msgHoliday || 'Riprendiamo le spedizioni il {date}';
      const msgClosed = el.dataset.msgClosed || 'Spedizione il prossimo giorno lavorativo';
      const msgCountdown = el.dataset.msgCountdown || 'Ordina entro {countdown} per spedizione oggi';
      const showCountdown = el.dataset.showCountdown === 'true';
      const showDelivery = el.dataset.showDelivery === 'true';
      const deliveryMin = parseInt(el.dataset.deliveryMin || '2', 10);
      const deliveryMax = parseInt(el.dataset.deliveryMax || '4', 10);
      const msgDelivery = el.dataset.msgDelivery || 'Consegna {dateMin}–{dateMax}';
      const holidays = parseHolidays(el.dataset.holidays);

      const now = new Date();
      const today = ymd(now);
      const isHoliday = holidays.has(today);
      const todayCutoff = cutoffForDay(el, now.getDay(), defaultCutoff);

      let mainMsg = '';
      let shipDate = null; // when the package is shipped (used for delivery estimate)

      if (isHoliday) {
        const next = nextShippingDay(el, now, defaultCutoff, holidays);
        const dateLbl = next ? fmtItalianDate(next) : '';
        mainMsg = msgHoliday.replace(/\{date\}/g, `<strong>${dateLbl}</strong>`);
        shipDate = next;
      } else if (todayCutoff === 'closed') {
        const next = nextShippingDay(el, now, defaultCutoff, holidays);
        const dateLbl = next ? fmtItalianDate(next) : '';
        mainMsg = msgClosed.replace(/\{date\}/g, `<strong>${dateLbl}</strong>`);
        shipDate = next;
      } else {
        const cut = parseHHMM(todayCutoff);
        const cutToday = new Date(now);
        if (cut) cutToday.setHours(cut.h, cut.m, 0, 0);
        const beforeCutoff = cut && now < cutToday;

        if (beforeCutoff) {
          shipDate = new Date(now);
          if (showCountdown) {
            const ms = cutToday - now;
            const totalMin = Math.max(0, Math.floor(ms / 60000));
            const h = Math.floor(totalMin / 60);
            const m = totalMin % 60;
            const cd = h > 0 ? `${h}h ${pad(m)}m` : `${m}m`;
            mainMsg = msgCountdown
              .replace(/\{countdown\}/g, `<strong>${cd}</strong>`)
              .replace(/\{time\}/g, `<strong>${todayCutoff}</strong>`);
          } else {
            mainMsg = msgBefore.replace(/\{time\}/g, `<strong>${todayCutoff}</strong>`);
          }
        } else {
          // Cutoff passed → ships next valid day
          const next = nextShippingDay(el, now, defaultCutoff, holidays);
          const dateLbl = next ? fmtItalianDate(next) : '';
          mainMsg = msgAfter
            .replace(/\{time\}/g, `<strong>${todayCutoff}</strong>`)
            .replace(/\{date\}/g, `<strong>${dateLbl}</strong>`);
          shipDate = next;
        }
      }

      // Optional delivery estimate suffix
      let deliveryMsg = '';
      if (showDelivery && shipDate) {
        const dMin = addBusinessDays(el, shipDate, deliveryMin, defaultCutoff, holidays);
        const dMax = addBusinessDays(el, shipDate, deliveryMax, defaultCutoff, holidays);
        deliveryMsg = msgDelivery
          .replace(/\{dateMin\}/g, `<strong>${fmtItalianDate(dMin)}</strong>`)
          .replace(/\{dateMax\}/g, `<strong>${fmtItalianDate(dMax)}</strong>`);
      }

      el.innerHTML = mainMsg + (deliveryMsg ? `<span class="product-details__status-cutoff-delivery"> · ${deliveryMsg}</span>` : '');
    }

    els.forEach(el => {
      compute(el);
      // Re-run every minute to keep the countdown live and to flip
      // before/after cutoff exactly at the change moment.
      const id = setInterval(() => compute(el), 60000);
      // Stop the timer if the element is detached (theme editor section
      // reload). Cheap MutationObserver on the element's parent.
      const parent = el.parentElement;
      if (parent) {
        const obs = new MutationObserver(() => {
          if (!document.contains(el)) {
            clearInterval(id);
            obs.disconnect();
          }
        });
        obs.observe(parent, { childList: true });
      }
    });
  })();

  /* ============================================================
     ACTION ROW — Share button trigger (delegates to native Share API
     or fallback to copy link). Wired to the inline action-row Share
     button which reuses the same logic as the dedicated `share_buttons`
     block but without rendering a separate widget.
     ============================================================ */
  (function initActionRowShare() {
    const btn = document.querySelector('[data-product-share-trigger]');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      const url = window.location.href;
      const title = document.title;
      try {
        if (navigator.share) {
          await navigator.share({ title, url });
        } else {
          await navigator.clipboard.writeText(url);
          // Brief visual feedback
          const orig = btn.querySelector('span').textContent;
          btn.querySelector('span').textContent = '✓';
          setTimeout(() => { btn.querySelector('span').textContent = orig; }, 1400);
        }
      } catch (err) { /* user cancelled */ }
    });
  })();

  /* ============================================================
     PAY NOTE (live recompute installments / price on variant change)
     ============================================================ */
  (function initPayNote() {
    const els = document.querySelectorAll('[data-pay-note]');
    if (els.length === 0) return;

    // Use the global formatMoney from theme.js (handles all Shopify
    // money format placeholders).

    function render(el, variant) {
      const tpl = el.dataset.template || '';
      const installments = parseInt(el.dataset.installments, 10) || 3;
      const minPrice = parseInt(el.dataset.minPrice, 10) || 0;
      const price = variant?.price ?? 0;

      // Hide if below threshold
      if (minPrice > 0 && price < minPrice) {
        el.hidden = true;
        return;
      }
      el.hidden = false;

      const installmentAmount = formatMoney(Math.round(price / installments));
      const fullPrice = formatMoney(price);
      const rendered = tpl
        .replace(/\{installments\}/g, installments)
        .replace(/\{installment\}/g, installmentAmount)
        .replace(/\{price\}/g, fullPrice);
      el.innerHTML = rendered;
    }

    document.addEventListener('lytta:variant:changed', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;
      els.forEach(el => render(el, variant));
    });
  })();

  /* ============================================================
     GUIDA ALLE TAGLIE
     ============================================================
     `<dialog>` fa da solo il lavoro che di solito si riscrive male a mano:
     lo sfondo, il tasto Esc, il fuoco che non esce dalla finestra e che
     torna sul pulsante alla chiusura. Qui restano due cose: aprirla, e
     chiuderla quando si clicca fuori. */
  (function initSizeGuide() {
    const apri = document.querySelector('[data-size-guide-open]');
    if (!apri) return;
    const finestra = document.getElementById(apri.dataset.sizeGuideOpen);
    if (!finestra) return;

    apri.addEventListener('click', () => finestra.showModal());
    finestra.querySelector('[data-size-guide-close]')
      ?.addEventListener('click', () => finestra.close());

    // Clic sullo sfondo. Il bersaglio del clic e' la <dialog> stessa solo
    // quando si preme FUORI dal contenuto: dentro, il bersaglio e' un figlio.
    finestra.addEventListener('click', (e) => {
      if (e.target === finestra) finestra.close();
    });
  })();

  /* ============================================================
     SPAZIO FRA SIMBOLO E CIFRA, DOPO IL CAMBIO DI VARIANTE
     ============================================================
     Il prezzo lo riscrive `theme.js` con la formattazione di Shopify, che
     il simbolo lo attacca alla cifra. Senza questo, lo spazio messo alla
     stampa della pagina sparirebbe al primo tocco su una taglia. Gira dopo,
     perche' l'evento viene emesso dopo la riscrittura. */
  (function initSpazioValuta() {
    const el = document.querySelector('[data-product-price][data-space-symbol]');
    if (!el) return;
    const simbolo = el.dataset.spaceSymbol;
    document.addEventListener('lytta:variant:changed', () => {
      const testo = el.textContent.trim();
      if (!testo.includes(simbolo)) return;
      el.textContent = testo.split(simbolo).join(simbolo + ' ').replace(/\s+/g, ' ').trim();
    });
  })();

  /* ============================================================
     INTERRUTTORE UOMO / DONNA
     ============================================================
     Nasconde le foto dell'altro scatto. Tre accortezze:

     - dopo il cambio la foto grande puo' essere una di quelle appena
       nascoste: si porta la galleria sulla prima rimasta;
     - il contatore "01/08" conterebbe anche le nascoste: si ricalcola;
     - la scelta si ricorda, perche' chi guarda lo scatto donna su un capo
       lo vuole anche sul successivo. */
  (function initGenderSwitch() {
    const gruppo = document.querySelector('[data-gender-switch]');
    if (!gruppo) return;
    const galleria = document.querySelector('.product-gallery');
    if (!galleria) return;
    const CHIAVE = 'lytta:gender';

    function applica(genere, muoviGalleria) {
      galleria.classList.remove('product-gallery--gender-uomo', 'product-gallery--gender-donna');
      galleria.classList.add('product-gallery--gender-' + genere);
      gruppo.querySelectorAll('[data-gender-pick]').forEach(b => {
        b.classList.toggle('is-active', b.dataset.genderPick === genere);
      });

      const slides = [...galleria.querySelectorAll('.product-gallery__slide')];
      const visibili = slides.filter(s => s.offsetParent !== null || getComputedStyle(s).display !== 'none');
      const totale = galleria.querySelector('[data-counter-total]');
      if (totale) totale.textContent = String(visibili.length).padStart(2, '0');

      if (!muoviGalleria) return;
      const attiva = galleria.querySelector('.product-gallery__slide.is-active');
      if (attiva && getComputedStyle(attiva).display === 'none') {
        const prima = slides.findIndex(s => getComputedStyle(s).display !== 'none');
        if (prima > -1) galleria.querySelector('[data-thumb="' + prima + '"]')?.click();
      }
    }

    gruppo.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gender-pick]');
      if (!b) return;
      const genere = b.dataset.genderPick;
      try { localStorage.setItem(CHIAVE, genere); } catch (err) { /* finestra privata */ }
      applica(genere, true);
    });

    let scelto = 'uomo';
    try { scelto = localStorage.getItem(CHIAVE) || 'uomo'; } catch (err) { /* finestra privata */ }
    if (!gruppo.querySelector('[data-gender-pick="' + scelto + '"]')) scelto = 'uomo';
    applica(scelto, true);
  })();

  /* ============================================================
     INLINE SKU SYNC — update the SKU in the meta-row on variant change
     ============================================================
     The SKU is rendered server-side from `current_variant.sku`. Without
     this listener, switching variants doesn't refresh it. If the new
     variant has no SKU, the wrapper hides itself (graceful — same
     pattern the server-side render uses with `current_variant.sku != blank`). */
  (function initSkuSync() {
    const wrap = document.querySelector('[data-product-sku]');
    if (!wrap) return;
    const skuEl = wrap.querySelector('span');
    if (!skuEl) return;
    document.addEventListener('lytta:variant:changed', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;
      if (variant.sku && variant.sku.trim() !== '') {
        skuEl.textContent = variant.sku;
        wrap.style.removeProperty('display');
      } else {
        wrap.style.display = 'none';
      }
    });
  })();

  /* Quantity cap is now handled globally in assets/theme.js so it works
     for both main product page AND quick-shop modal (which is fetched
     into the DOM on catalog pages where this section JS isn't loaded). */

  /* ============================================================
     DELIVERY ESTIMATE (computes dates client-side from min/max days)
     ============================================================ */
  (function initDeliveryEstimate() {
    const widgets = document.querySelectorAll('[data-delivery-estimate]');
    if (widgets.length === 0) return;

    widgets.forEach(widget => {
      const minDays = parseInt(widget.dataset.minDays, 10) || 2;
      const maxDays = parseInt(widget.dataset.maxDays, 10) || 4;
      const cutoffHour = parseInt(widget.dataset.cutoffHour, 10) || 14;
      const skipWeekends = widget.dataset.skipWeekends === 'true';
      const range = widget.querySelector('[data-delivery-dates]');
      if (!range) return;

      const now = new Date();
      // If order is placed after cutoff hour, shipping starts next day
      const start = new Date(now);
      if (now.getHours() >= cutoffHour) start.setDate(start.getDate() + 1);

      const addBusinessDays = (date, days) => {
        const d = new Date(date);
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (!skipWeekends) { added++; continue; }
          const day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      };

      const earliest = addBusinessDays(start, minDays);
      const latest = addBusinessDays(start, maxDays);
      const locale = document.documentElement.lang || navigator.language || 'en';

      const fmt = (d) => d.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' });

      range.textContent = `${fmt(earliest)} – ${fmt(latest)}`;
    });
  })();

/* ============================================================
   ZOOM A LENTE CON PANNELLO (stile Amazon)
   ============================================================
   Attivo solo quando la sezione e' impostata su "hover_pane" e solo dove
   esiste un mouse: su uno schermo che si tocca non c'e' niente su cui
   passare sopra, e resta la finestra a tutto schermo. */
(function initZoomPane() {
  const galleria = document.querySelector('.product-gallery--zoom-hover_pane');
  if (!galleria) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const principale = galleria.querySelector('.product-gallery__main');
  const lente = galleria.querySelector('[data-zoom-lens]');
  const pannello = galleria.querySelector('[data-zoom-pane]');
  if (!principale || !lente || !pannello) return;

  const precaricate = new Set();
  let m = null;   // le misure, lette una volta all'ingresso

  function fotoGrande() {
    const attiva = galleria.querySelector('.product-gallery__slide.is-active');
    if (!attiva) return null;
    const img = attiva.querySelector('.product-gallery__img');
    if (!img) return null;
    const btn = attiva.querySelector('[data-zoom]');
    return { img, src: (btn && btn.dataset.src) || img.currentSrc || img.src };
  }

  function misura() {
    const dati = fotoGrande();
    if (!dati || !dati.src) return null;

    // Si precarica una volta sola: senza, il pannello resta bianco per un
    // istante al primo movimento su ogni foto.
    if (!precaricate.has(dati.src)) {
      const pre = new Image();
      pre.src = dati.src;
      precaricate.add(dati.src);
    }

    const r = dati.img.getBoundingClientRect();
    if (r.width === 0) return null;
    // La misura del pannello non si CHIEDE, si DA': un elemento nascosto
    // misura zero, ed era il motivo per cui il calcolo si fermava. Il
    // pannello e' grande quanto il contenitore della foto.
    const base = principale.getBoundingClientRect();
    pannello.style.width = base.width + 'px';
    pannello.style.height = base.height + 'px';
    const p = { width: base.width, height: base.height };

    // Quanto si ingrandisce: la larghezza della sorgente contro quella a
    // schermo. Su una galleria da 650px con una foto da 1800 sono 2,8 volte.
    // La larghezza da cui dipende l'ingrandimento e' quella della foto che
    // finisce NEL PANNELLO, non di quella visibile in galleria: la seconda
    // il browser la sceglie dal `srcset` e puo' essere molto piu' piccola.
    // Shopify scrive la misura nell'indirizzo; `naturalWidth` resta un
    // ripiego, e vale zero finche' l'immagine non e' arrivata.
    const dichiarata = dati.src.match(/[?&]width=(\d+)/);
    let naturale = dichiarata ? parseInt(dichiarata[1], 10) : 0;
    if (!naturale) naturale = dati.img.naturalWidth || r.width * 2;
    const fattore = naturale / r.width;

    return {
      src: dati.src,
      rect: r,
      // Il riquadro e' grande quanto la porzione che il pannello mostra.
      lenteW: p.width / fattore,
      lenteH: p.height / fattore,
      sfondoW: r.width * fattore,
      sfondoH: r.height * fattore,
      fattore: fattore,
    };
  }

  function entra() {
    // Si accende PRIMA di misurare: il pannello e' `display: none` finche'
    // la classe non c'e', e un elemento nascosto misura zero. Se poi il
    // calcolo non torna, si spegne.
    galleria.classList.add('is-zooming');
    m = misura();
    if (!m) {
      galleria.classList.remove('is-zooming');
      return;
    }
    pannello.style.backgroundImage = 'url("' + m.src + '")';
    pannello.style.backgroundSize = m.sfondoW + 'px ' + m.sfondoH + 'px';
    lente.style.width = m.lenteW + 'px';
    lente.style.height = m.lenteH + 'px';
  }

  function muovi(e) {
    if (!m) return;
    // Il riquadro segue il mouse ma non esce dai bordi: oltre l'immagine il
    // pannello mostrerebbe il vuoto.
    let x = e.clientX - m.rect.left - m.lenteW / 2;
    let y = e.clientY - m.rect.top - m.lenteH / 2;
    x = Math.max(0, Math.min(x, m.rect.width - m.lenteW));
    y = Math.max(0, Math.min(y, m.rect.height - m.lenteH));

    const base = principale.getBoundingClientRect();
    const sinistra = m.rect.left - base.left;
    const alto = m.rect.top - base.top;
    lente.style.transform = 'translate(' + (x + sinistra) + 'px,' + (y + alto) + 'px)';
    pannello.style.backgroundPosition = (-x * m.fattore) + 'px ' + (-y * m.fattore) + 'px';
  }

  function esci() {
    galleria.classList.remove('is-zooming');
    m = null;
  }

  principale.addEventListener('mouseenter', entra);
  principale.addEventListener('mousemove', muovi);
  principale.addEventListener('mouseleave', esci);
  // Cambiando diapositiva cambia anche la foto da ingrandire: le misure
  // vecchie punterebbero all'immagine precedente.
  galleria.addEventListener('click', () => { if (m) m = misura(); });
})();

/* ============================================================
   IL DESTINATARIO DEL BUONO REGALO

   Il markup arriva gia' funzionante senza di me: la casella e' `disabled` e
   il campo nascosto vale `if_present`, cioe' "manda al destinatario solo se
   un dato del destinatario c'e'". Chi ha javascript spento vede i campi,
   li compila se vuole, e il buono parte giusto.

   Qui si aggiunge solo il comodo: i campi compaiono quando servono e
   spariscono quando no.

   Due cose che sembrano dettagli e non lo sono:

   * i campi nascosti vengono anche **disabilitati**. Un campo nascosto ma
     attivo viene spedito lo stesso, e un "Recipient email" vuoto in mezzo
     alle proprieta' della riga d'ordine diventa una riga vuota nel
     carrello e nella mail di conferma;

   * `__shopify_offset` porta il fuso di chi compra. Senza, "manda il 24
     dicembre" e' il 24 dicembre del fuso di Shopify, che per qualcuno e'
     ancora il 23.
   ============================================================ */
(function () {
  const blocchi = document.querySelectorAll('[data-gift-recipient]');
  if (!blocchi.length) return;

  blocchi.forEach(function (blocco) {
    const spunta = blocco.querySelector('[data-gift-recipient-checkbox]');
    const campi = blocco.querySelector('[data-gift-recipient-fields]');
    if (!spunta || !campi) return;

    const email = blocco.querySelector('[data-gift-recipient-email]');
    const data = blocco.querySelector('[data-gift-recipient-date]');
    const fuso = blocco.querySelector('[data-gift-recipient-offset]');
    const dentro = campi.querySelectorAll('input, textarea');

    // Un buono non si puo' consegnare ieri, e nemmeno fra un anno: Shopify
    // rifiuta "Send on" oltre **90 giorni** con un 422 che, senza questi due
    // limiti, il cliente scopre solo dopo aver premuto "aggiungi al
    // carrello". Meglio che il campo non glielo faccia proprio scegliere.
    if (data && !data.min) {
      const oggi = new Date();
      const giorno = function (d) { return d.toISOString().slice(0, 10); };
      data.min = giorno(oggi);
      const limite = new Date(oggi);
      limite.setDate(limite.getDate() + 90);
      data.max = giorno(limite);
    }

    function aggiorna() {
      const acceso = spunta.checked;
      campi.hidden = !acceso;
      dentro.forEach(function (c) { c.disabled = !acceso; });
      if (email) email.required = acceso;
      if (fuso) {
        fuso.disabled = !acceso;
        fuso.value = acceso ? String(new Date().getTimezoneOffset()) : '';
      }
    }

    // Si accende solo ora: prima di questo punto la casella non deve essere
    // inviabile, altrimenti senza javascript direbbe "manda al destinatario"
    // con i campi vuoti.
    spunta.disabled = false;
    spunta.addEventListener('change', aggiorna);
    aggiorna();
  });
})();
